import React, { useState } from 'react';
import { array, arrayOf, bool, object, shape } from 'prop-types';
import { didSortChange, getTransformedColumns } from 'ps-components/AdvancedTable/GenericGrid/GenericGridFunctions';
import AdvancedTable from 'ps-components/AdvancedTable/AdvancedTable';
import './JobEmployeesGrid.scss';

function JobEmployeesGrid(props) {
  const { jobEmployeesData, jobEmployeesGrid, loading, onSortChange, showJobCodeKey } = props;

  if (!jobEmployeesData) {
    return null;
  }

  const [sortState, setSortState] = useState(null);
  const { data, terms, termGroups } = jobEmployeesData;

  const filteredTerms = showJobCodeKey ? terms : terms.filter(term => term.fieldName !== 'org_job_code_key');
  const filteredIndex = showJobCodeKey ? -1 : terms.findIndex(term => term.fieldName == 'org_job_code_key');
  for (let i = 0; i < data.length; i++) {
    if (filteredIndex > -1) {
      data[i].splice(filteredIndex, 1);
    }
  }

  const { defaultLeftColumns, tableProps } = jobEmployeesGrid;
  const columns = getTransformedColumns(termGroups, filteredTerms, data, defaultLeftColumns, null);

  function handleOnSortChange(sort) {
    const sortChanged = sortState !== null && didSortChange(sort, sortState);
    setSortState(sort);
    if (sortChanged && sortState) props.onSortChange(sort);
  }

  return (
    <AdvancedTable
      {...tableProps}
      allowSorting={true}
      columnHeaders={columns}
      dataLoading={loading}
      loadingText="Loading Employee Data"
      noDataText="No Employees Found"
      onSortChange={handleOnSortChange}
      rowData={data}
      stickyHeader
      totalCount={data?.length}
      useClientSideSort={false}
    />
  );
}

JobEmployeesGrid.propTypes = {
  jobEmployeesData: shape({
    data: arrayOf(array),
    metadata: object,
    terms: arrayOf(object)
  }),
  onSortChange: object,
  loading: bool
};

export default JobEmployeesGrid;
